import React, { useEffect, useState } from "react";

import { observer } from "mobx-react";
import { Col, Row, Form } from "react-bootstrap";
import moment from "moment";

import { BottomsheetDropdown, DatepickerModal, CustomCheckbox, DeathCoverPriceComponent, ChangeProductSection } from "components";
import AmountCalculation from "../../optimization-card/amount-calculation/AmountCalculation";
import DeathCoverGraphSlider from "../../death-cover-graph-slider/DeathCoverGraphSlider";
import AdditionalRiderBenifitsCard from "components/ui/additional-rider-benifits-card/AdditionalRiderBenifitsCard";
import Utils from "./utils";
// import AdditionalCards from "./component/addtional-cards/AdditionalCards";
import fetchIncomeLabelBasedOnNeed from "utils/fetchIncomeLabelBasedOnNeed";
import deathCoverPriceLabelFunction from "utils/deathCoverPriceLabelFunction";
import DeathBenefitAmount from "utils/optimization/deathBenefitAmount";
import CompareProductModal from "components/ui/compare-products-modal/CompareProductsModal";
import ViewBonusHistoryButton from "components/ui/view-bonus-history/ViewBonusHistoryButton"
import OptimizationStore from "modules/optimization/store/OptimizationStore";
import ComapreQuotesTable from "components/ui/compare-quotes-table/ComapreQuotesTable";
import StorageKeys from "constants/StorageKeys";


const BharatSavingsStar = (props) => {
  const [showOverlay, setShowOverlay] = useState(false);

  const { form, data } = props;
  let productData = data.data;
  let biResponse = productData.parsedResponse;
  let firstYearResponse = productData.firstYearResponse;
  let coverLabelBaseOnNeed = fetchIncomeLabelBasedOnNeed(data.cardKey);


  useEffect(() => {
    setShowOverlay(productData.fieldChanged);
  }, [productData.fieldChanged]);

  const onHideOverlay = () => {
    setShowOverlay(false);
  };


  return (
    <div className=''>
      <Row className="align-items-center mt-4">
        <Col md={12} className='mt-3 mt-md-0'>
          <ChangeProductSection
            productName={productData.product_name}
            familyProductId={productData.family_product_id}
            cardName={coverLabelBaseOnNeed}
            changeProductList={productData.changeProductList}
            productData={data}
            form={form}
          />
        </Col>
      </Row>
      <Row>
        <Col md={12}>
          <ComapreQuotesTable
           form={form}
            ptList={form.$("policy-term").extra.optionList}
            pptList={form.$("premium-paying-term").extra.optionList}
            ptValueId={form.$("policy-term").value}
            ptName={"policy-term"}
            pptName={"premium-paying-term"}
            productData={data}
            cardKey={data.cardKey}
          />
        </Col>
      </Row>




      <Col md={12} className='col-12 mt-2 mt-md-0'>
        <DeathCoverGraphSlider
          productTitle='Bharat Savings Star'
          openChangeReasonModal={false}
          onIncomeChange={() => { }}
          onPremiumChange={form.$("premium").onChange}
          productID={productData.product_id}
          productData={productData}
          income_value={form.$("income").value}
          premium_value={form.$("premium").value}
          showOverlay={showOverlay}
          hideOverLay={onHideOverlay}
          onClick={() => form.$("premium").extra.calculatePremium(form, data)}
          data=''
          cardKey={data.cardKey}
          isIncomeFieldDisable={form.$("premium").disabled}
          premiumFreq={form.$("premium-paying-frequency").value.label}
          form={form}
          recommendedPremium={productData?.recommended_premium}
          recommendedTargetValue={productData?.recommended_sum_assured}
        />
      </Col>


      <Row className='mt-3 ml-0'>
        <p className='graph-label mb-2 font-size-12 font-size-md-14 font-weight-bold'>{"Sum Assured on Death (at inception of the policy):"}</p>
        <p className='graph-label pl-1 font-size-12 font-size-md-14 font-weight-bold'>{DeathBenefitAmount(productData)}</p>
      </Row>

      <Row className='mt-2 mt-md-4'>
        <Col md={6} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("policy-term").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("policy-term").label}
            menuList={form.$("policy-term").extra.optionList}
            value={form.$("policy-term").value}
            onSelect={form.$("policy-term").onChange}
            disabled={form.$("policy-term").disabled}
          />
          {/* </div> */}
        </Col>
        <Col md={6} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-paying-term").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-paying-term").label}
            menuList={form.$("premium-paying-term").extra.optionList}
            value={form.$("premium-paying-term").value}
            disabled={form.$("premium-paying-term").disabled}
            onSelect={form.$("premium-paying-term").onChange}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-paying-frequency").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-paying-frequency").label}
            menuList={form.$("premium-paying-frequency").extra.optionList}
            value={form.$("premium-paying-frequency").value}
            onSelect={form.$("premium-paying-frequency").onChange}
            disabled={form.$("premium-paying-frequency").disabled}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("income-benefit-payout-frequency").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("income-benefit-payout-frequency").label}
            menuList={form.$("income-benefit-payout-frequency").extra.optionList}
            value={form.$("income-benefit-payout-frequency").value}
            onSelect={form.$("income-benefit-payout-frequency").onChange}
            disabled={form.$("income-benefit-payout-frequency").disabled}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("plan-option").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("plan-option").label}
            menuList={form.$("plan-option").extra.optionList}
            value={form.$("plan-option").value}
            onSelect={form.$("plan-option").onChange}
            disabled={form.$("plan-option").disabled}
          />
          {/* </div> */}
        </Col>
        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("premium-break-benefit").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("premium-break-benefit").label}
            menuList={form.$("premium-break-benefit").extra.optionList}
            value={form.$("premium-break-benefit").value}
            onSelect={form.$("premium-break-benefit").onChange}
            disabled={form.$("premium-break-benefit").disabled}
          />
          {/* </div> */}
        </Col>

        <Col md={4} className='col-12 mb-3'>
          {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("accrual-of-survival-benefits").label}
            menuList={form.$("accrual-of-survival-benefits").extra.optionList}
            value={form.$("accrual-of-survival-benefits").value}
            onSelect={form.$("accrual-of-survival-benefits").onChange}
            disabled={form.$("accrual-of-survival-benefits").disabled}
          />
          {/* </div> */}
        </Col>

        {!form.$("asb-start-policy-year-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-policy-year-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-policy-year-(1st-opt-in)").label}
              menuList={form.$("asb-start-policy-year-(1st-opt-in)").extra.optionList}
              value={form.$("asb-start-policy-year-(1st-opt-in)").value}
              onSelect={form.$("asb-start-policy-year-(1st-opt-in)").onChange}
              disabled={form.$("asb-start-policy-year-(1st-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-policy-year-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-policy-year-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-policy-year-(1st-opt-in)").label}
              menuList={form.$("asb-end-policy-year-(1st-opt-in)").extra.optionList}
              value={form.$("asb-end-policy-year-(1st-opt-in)").value}
              onSelect={form.$("asb-end-policy-year-(1st-opt-in)").onChange}
              disabled={form.$("asb-end-policy-year-(1st-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("accrual-of-survival-benefits-year-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-2").label}
              menuList={form.$("accrual-of-survival-benefits-year-2").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-2").value}
              onSelect={form.$("accrual-of-survival-benefits-year-2").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-2").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-start-policy-year-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-policy-year-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-policy-year-(2nd-opt-in)").label}
              menuList={form.$("asb-start-policy-year-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-start-policy-year-(2nd-opt-in)").value}
              onSelect={form.$("asb-start-policy-year-(2nd-opt-in)").onChange}
              disabled={form.$("asb-start-policy-year-(2nd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-policy-year-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-policy-year-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-policy-year-(2nd-opt-in)").label}
              menuList={form.$("asb-end-policy-year-(2nd-opt-in)").extra.optionList}
              value={form.$("asb-end-policy-year-(2nd-opt-in)").value}
              onSelect={form.$("asb-end-policy-year-(2nd-opt-in)").onChange}
              disabled={form.$("asb-end-policy-year-(2nd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("accrual-of-survival-benefits-year-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("accrual-of-survival-benefits-year-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("accrual-of-survival-benefits-year-3").label}
              menuList={form.$("accrual-of-survival-benefits-year-3").extra.optionList}
              value={form.$("accrual-of-survival-benefits-year-3").value}
              onSelect={form.$("accrual-of-survival-benefits-year-3").onChange}
              disabled={form.$("accrual-of-survival-benefits-year-3").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-start-policy-year-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-start-policy-year-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-start-policy-year-(3rd-opt-in)").label}
              menuList={form.$("asb-start-policy-year-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-start-policy-year-(3rd-opt-in)").value}
              onSelect={form.$("asb-start-policy-year-(3rd-opt-in)").onChange}
              disabled={form.$("asb-start-policy-year-(3rd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("asb-end-policy-year-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("asb-end-policy-year-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("asb-end-policy-year-(3rd-opt-in)").label}
              menuList={form.$("asb-end-policy-year-(3rd-opt-in)").extra.optionList}
              value={form.$("asb-end-policy-year-(3rd-opt-in)").value}
              onSelect={form.$("asb-end-policy-year-(3rd-opt-in)").onChange}
              disabled={form.$("asb-end-policy-year-(3rd-opt-in)").disabled}
            />
            {/* </div> */}
          </Col>
        }


        {!form.$("preponement-of-future-income").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            {/* <div className='shadow p-3 bg-white rounded mt-4 mb-3'> */}
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("preponement-of-future-income").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("preponement-of-future-income").label}
              menuList={form.$("preponement-of-future-income").extra.optionList}
              value={form.$("preponement-of-future-income").value}
              onSelect={form.$("preponement-of-future-income").onChange}
              disabled={form.$("preponement-of-future-income").disabled}
            />
            {/* </div> */}
          </Col>
        }

        {!form.$("pfi-start-policy-year-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-start-policy-year-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-start-policy-year-(1st-opt-in)").label}
              menuList={form.$("pfi-start-policy-year-(1st-opt-in)").extra.optionList}
              value={form.$("pfi-start-policy-year-(1st-opt-in)").value}
              onSelect={form.$("pfi-start-policy-year-(1st-opt-in)").onChange}
              disabled={form.$("pfi-start-policy-year-(1st-opt-in)").disabled}
            />
          </Col>
        }

        {!form.$("pfi-end-policy-year-(1st-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-end-policy-year-(1st-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-end-policy-year-(1st-opt-in)").label}
              menuList={form.$("pfi-end-policy-year-(1st-opt-in)").extra.optionList}
              value={form.$("pfi-end-policy-year-(1st-opt-in)").value}
              onSelect={form.$("pfi-end-policy-year-(1st-opt-in)").onChange}
              disabled={form.$("pfi-end-policy-year-(1st-opt-in)").disabled}
            />
          </Col>
        }

        {!form.$("preponement-year-2").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("preponement-year-2").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("preponement-year-2").label}
              menuList={form.$("preponement-year-2").extra.optionList}
              value={form.$("preponement-year-2").value}
              onSelect={form.$("preponement-year-2").onChange}
              disabled={form.$("preponement-year-2").disabled}
            />
          </Col>
        }

        {!form.$("pfi-start-policy-year-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-start-policy-year-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-start-policy-year-(2nd-opt-in)").label}
              menuList={form.$("pfi-start-policy-year-(2nd-opt-in)").extra.optionList}
              value={form.$("pfi-start-policy-year-(2nd-opt-in)").value}
              onSelect={form.$("pfi-start-policy-year-(2nd-opt-in)").onChange}
              disabled={form.$("pfi-start-policy-year-(2nd-opt-in)").disabled}
            />
          </Col>
        }

        {!form.$("pfi-end-policy-year-(2nd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-end-policy-year-(2nd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-end-policy-year-(2nd-opt-in)").label}
              menuList={form.$("pfi-end-policy-year-(2nd-opt-in)").extra.optionList}
              value={form.$("pfi-end-policy-year-(2nd-opt-in)").value}
              onSelect={form.$("pfi-end-policy-year-(2nd-opt-in)").onChange}
              disabled={form.$("pfi-end-policy-year-(2nd-opt-in)").disabled}
            />
          </Col>
        }

        {!form.$("preponement-year-3").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("preponement-year-3").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("preponement-year-3").label}
              menuList={form.$("preponement-year-3").extra.optionList}
              value={form.$("preponement-year-3").value}
              onSelect={form.$("preponement-year-3").onChange}
              disabled={form.$("preponement-year-3").disabled}
            />
          </Col>
        }

        {!form.$("pfi-start-policy-year-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-start-policy-year-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-start-policy-year-(3rd-opt-in)").label}
              menuList={form.$("pfi-start-policy-year-(3rd-opt-in)").extra.optionList}
              value={form.$("pfi-start-policy-year-(3rd-opt-in)").value}
              onSelect={form.$("pfi-start-policy-year-(3rd-opt-in)").onChange}
              disabled={form.$("pfi-start-policy-year-(3rd-opt-in)").disabled}
            />
          </Col>

        }

        {!form.$("pfi-end-policy-year-(3rd-opt-in)").extra.hide &&
          <Col md={4} className='col-12 mb-3'>
            <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("pfi-end-policy-year-(3rd-opt-in)").label}</div>
            <BottomsheetDropdown
              dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
              menuItemStyle='d-flex justify-content-between align-items-center'
              selectedLabelKey='label'
              bottomsheetTitle={form.$("pfi-end-policy-year-(3rd-opt-in)").label}
              menuList={form.$("pfi-end-policy-year-(3rd-opt-in)").extra.optionList}
              value={form.$("pfi-end-policy-year-(3rd-opt-in)").value}
              onSelect={form.$("pfi-end-policy-year-(3rd-opt-in)").onChange}
              disabled={form.$("pfi-end-policy-year-(3rd-opt-in)").disabled}
            />
          </Col>
        }

        <Col md={4} className='col-12 mb-3'>
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("auto-renewal-booster").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("auto-renewal-booster").label}
            menuList={form.$("auto-renewal-booster").extra.optionList}
            value={form.$("auto-renewal-booster").value}
            onSelect={form.$("auto-renewal-booster").onChange}
            disabled={form.$("auto-renewal-booster").disabled}
          />
        </Col>


        <Col md={4} className='col-12 mb-3'>
          <div className='mb-1 text-description-text-color font-size-12 font-weight-light'>{form.$("sum-assured-on-death-multiple").label}</div>
          <BottomsheetDropdown
            dropdownStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemFontStyle='font-size-lg-12 font-size-14 font-weight-light'
            menuItemStyle='d-flex justify-content-between align-items-center'
            selectedLabelKey='label'
            bottomsheetTitle={form.$("sum-assured-on-death-multiple").label}
            menuList={form.$("sum-assured-on-death-multiple").extra.optionList}
            value={form.$("sum-assured-on-death-multiple").value}
            onSelect={form.$("sum-assured-on-death-multiple").onChange}
            disabled={form.$("sum-assured-on-death-multiple").disabled}
          />
        </Col>
      </Row>
      <Row className='mt-4'>
        <Col md={6} className='col-12 mt-4 mt-md-0'>
          <AdditionalRiderBenifitsCard
            data={data}
            form={form}
            showCriticalIllness={true}
            showIncomeBenefit={false}
            showHospitalityCashBenefit={false}
            showWOP={true}
            showPWB={true}
          />
        </Col>
      </Row>
    </div >


  )


};
export default observer(BharatSavingsStar);